import { useQuery } from "@tanstack/react-query";
export const createUsersAchievementsQueries = (requests, queryClient) => ({
    useListUsersAchievements: (params, options = {}) => useQuery({
        queryKey: ["users_achievements", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listUsersAchievements(params);
        },
        ...options,
    }),
    useFindUserAchievement: (params, options = {}) => useQuery({
        queryKey: ["users_achievements", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findUserAchievement(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map